import { WEBSOCKET_EVENT_INPLAY_START, WEBSOCKET_EVENT_INPLAY_UPDATE } from '../CommonDataStore/constants';

export const WS_HANDLER_COMPONENT_NAME = 'commonDataListEventsReducer';
export const WS_MSG_ACTION_INPLAY_START = WEBSOCKET_EVENT_INPLAY_START;
export const WS_MSG_ACTION_INPLAY_UPDATE = WEBSOCKET_EVENT_INPLAY_UPDATE;
